import {doFetch} from './fetch';
import {fetchCsrfToken} from '../csrf-token-module.js';
import * as logger from '../datadog-browser-logging.js';
import * as loadingMask from './load-mask.js';

/**
 * Add event listener to the coupon box to toggle the collapsed state.
 */
function toggleCouponBox() {
  const couponBox = document.querySelector('.js_coupon_box');
  if (!couponBox) {
    return;
  }

  couponBox.addEventListener('click', (event) => {
    // If the user clicks on a child element of the coupon box, do nothing.
    // So the box does not collapse when the user clicks on the input field.
    if (couponBox !== event.target) {
      return;
    }

    couponBox.classList.toggle('collapsed');
  });
}

function addCodeRedemptionListeners() {
  const codeField = document.getElementById('codeField');
  if (!codeField) {
    return;
  }

  codeField.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      applyCouponCode(codeField.value);
    }
  });

  document.getElementById('js-redeem-coupon').addEventListener('click', () => applyCouponCode(codeField.value));

  if (localStorage.getItem('couponCodeRecentlyRedeemed') === 'true') {
    createFeedbackDialog('feedback_success', 'Super, dein Gutschein wurde erfolgreich hinzugefügt.', 3000);
    localStorage.setItem('couponCodeRecentlyRedeemed', 'false');
  }

  if (localStorage.getItem('couponCodeError') && localStorage.getItem('couponCodeError') !== 'false') {
    createFeedbackDialog('feedback_error', localStorage.getItem('couponCodeError'));
    localStorage.setItem('couponCodeError', 'false');
  }
}

function applyCouponCode(code) {
  loadingMask.show();
  const formData = new FormData();
  formData.append('couponCode', code);
  doFetch(
      '/basketActionEndpoint.php?action=redeemCouponCode',
      {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-Token': fetchCsrfToken(),
        },
      },
      (response) => {
        if (response.success) {
          localStorage.setItem('couponCodeRecentlyRedeemed', 'true');
        } else {
          localStorage.setItem('couponCodeError', response.error);
        }
        window.location.reload();
      },
  );
}

function removeVoucher(id) {
  loadingMask.show();
  const formData = new FormData();
  formData.append('voucherId', id);
  doFetch(
      '/basketActionEndpoint.php?action=removeVoucher',
      {
        method: 'POST',
        body: formData,
        headers: {
          'X-CSRF-Token': fetchCsrfToken(),
        },
      },
      (response) => {
        if (response.success) {
          window.location.reload();
        } else {
          createFeedbackDialog('feedback_error', response.error);
          loadingMask.hide();
        }
      },
  );
}

function addRemoveCouponsListener() {
  document.querySelectorAll('.js_remove_coupon').forEach(element => element.addEventListener('click', () =>
      fetch(
          '/shopController.php?objective=removeCouponCodes',
          {
            method: 'POST',
            headers: {
              'X-CSRF-Token': fetchCsrfToken(),
            },
          },
      )
          .then(() => window.location.reload())
          .catch(logger.logError),
  ));
}

function addVoucherListeners() {
  document.querySelectorAll('.js_voucher').forEach((el) => {
    el.addEventListener('click', function(e) {
      if (el.classList.contains('active')) {
        removeVoucher(el.dataset.id);
      } else {
        applyCouponCode(el.dataset.code);
      }
    });
  });

  document.querySelectorAll('.js_remove_voucher').forEach((el) => {
    el.addEventListener('click', function(e) {
      removeVoucher(el.dataset.id);
    });
  });
}

function addCouponListeners() {
  toggleCouponBox();
  addCodeRedemptionListeners();
  addRemoveCouponsListener();
  addVoucherListeners();
}

export {
  addCouponListeners,
  addRemoveCouponsListener,
};